import { combineReducers } from 'redux';
import authReducer from './auth';
import articleReducer from'./submitarticle';
import customerConfigReducer from './cusconfig';

const rootReducer = combineReducers({
    authReducer: authReducer,
    articleReducer: articleReducer,
    customerConfigReducer: customerConfigReducer
});

export default rootReducer;